import { COLOR_OPTIONS } from 'config/style';
import type { RegionalOverviewLevel } from '../../regional-overview.models';

export enum StressRiskLevel {
  NONE = 0,
  COLD_LOW = 1,
  COLD_MEDIUM = 2,
  COLD_HIGH = 3,
  HEAT_LOW = 4,
  HEAT_MEDIUM = 5,
  HEAT_HIGH = 6
}

export interface StressRiskLevelResponse {
  level: StressRiskLevel;
  type: string;
}

export interface AbioticStressProperties {
  values: {
    crop_name: string;
    risk: number;
  };
}

export const RegionalRiskLevelColor = {
  NO_RISK: COLOR_OPTIONS.NEUTRAL_30,
  COLD_LOW_RISK: COLOR_OPTIONS.BLUE_30,
  COLD_MEDIUM_RISK: COLOR_OPTIONS.BLUE_40,
  COLD_HIGH_RISK: COLOR_OPTIONS.BLUE_50,
  HEAT_LOW_RISK: COLOR_OPTIONS.RED_30,
  HEAT_MEDIUM_RISK: COLOR_OPTIONS.RED_40,
  HEAT_HIGH_RISK: COLOR_OPTIONS.RED_50
} as const;

export type RegionalRiskLevelColor = (typeof RegionalRiskLevelColor)[keyof typeof RegionalRiskLevelColor];

export const abioticStressLevels: RegionalOverviewLevel[] = [
  {
    type: 'no_risk',
    value: '0',
    level: 10,
    legend_color: RegionalRiskLevelColor.NO_RISK,
    text_color: COLOR_OPTIONS.NEUTRAL_80
  },
  {
    type: 'low_risk',
    value: '1',
    level: 15,
    legend_color: RegionalRiskLevelColor.COLD_LOW_RISK,
    text_color: COLOR_OPTIONS.NEUTRAL_80
  },
  {
    type: 'medium_risk',
    value: '2',
    level: 15,
    legend_color: RegionalRiskLevelColor.COLD_MEDIUM_RISK,
    text_color: COLOR_OPTIONS.NEUTRAL_80
  },
  {
    type: 'high_risk',
    value: '3',
    level: 15,
    legend_color: RegionalRiskLevelColor.COLD_HIGH_RISK,
    text_color: COLOR_OPTIONS.NEUTRAL_80
  },
  {
    type: 'low_risk',
    value: '4',
    level: 15,
    legend_color: RegionalRiskLevelColor.HEAT_LOW_RISK,
    text_color: COLOR_OPTIONS.NEUTRAL_80
  },
  {
    type: 'medium_risk',
    value: '5',
    level: 15,
    legend_color: RegionalRiskLevelColor.HEAT_MEDIUM_RISK,
    text_color: COLOR_OPTIONS.NEUTRAL_80
  },
  {
    type: 'high_risk',
    value: '6',
    level: 15,
    legend_color: RegionalRiskLevelColor.HEAT_HIGH_RISK,
    text_color: COLOR_OPTIONS.NEUTRAL_80
  }
];
